import React, { FC, useEffect, useState } from 'react';
import { Progress } from 'antd';
import styled from 'styled-components';
import arrowImg from './assets/synchronize-arrows-square.png';
import { Paragraph } from 'hui';
import { alignCenter, SynchronizeArrowsImg } from './style';

const ProcessSuccessWrapper = styled.div`
  ${alignCenter};
`;

const ProcessWrapper = styled.div`
  flex: 1;
`;

interface ParsingProgressProps {
  parseFinalResult: string;
  closeParseProgressBar(parseResult: string): void;
}

const ParsingProgress: FC<ParsingProgressProps> = ({ parseFinalResult, closeParseProgressBar }) => {
  const [parseProgress, setParseProgress] = useState(0);

  useEffect(() => {
    const timeoutNum = setTimeout(() => {
      if (parseProgress !== 100) {
        setParseProgress((progress: number) => progress + 1);
      } else {
        closeParseProgressBar(parseFinalResult);
      }
    }, 20);
    return () => {
      clearTimeout(timeoutNum);
    };
  }, [parseProgress]);

  return (
    <ProcessSuccessWrapper>
      <SynchronizeArrowsImg alt="synchronize arrows square" src={arrowImg} />
      <ProcessWrapper>
        <Paragraph mb={0}>Parsing progress</Paragraph>
        <Progress percent={parseProgress} strokeWidth={5} />
      </ProcessWrapper>
    </ProcessSuccessWrapper>
  );
};

export default ParsingProgress;
